<template>
  <div class="newsDetail" v-if="detail">
    <nav-header></nav-header>
    <div class="sec-main" style="width: 1056px;margin-left: auto;margin-right: auto;">
      <!-- list -->
      <div class="list-wrapper">
        <h3 class="new-article-title">{{detail.Title}}</h3>
        <!-- html内容 -->
        <div v-html="detail.Content"></div>
        <div class="new-operation-btn" style="height: 88px;">
          <span class="issue-time">发布于{{detail.CreateTime}}·著作权归作者所有</span>
          <div class="operation-btn">
            <span class="dz" :class="{'icon-yes-praise':detail.IsThumbUp}" @click="forumThumbUp">{{detail.ThumbUpCount}}</span>
            <span class="sc" :class="{'icon-yes-collect':detail.IsCollect}" @click="forumCollectPost">{{detail.CollectCount}}</span>
            <el-dropdown trigger="click" placement="bottom" @command="commandMore">
              <span class="icon-more">点点点</span>
              <el-dropdown-menu slot="dropdown" class="text-center">
                <el-dropdown-item :command="textHandleCommand('k')">复制链接</el-dropdown-item>
                <el-dropdown-item :command="textHandleCommand('j')">举报</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div style="height: 10px;background: #f9f9f9;font-size: 0;">分割线</div>
        <div class="contentNum-actions">
          <div class="comment-number">
            <i>{{detail.CommentCount}}</i>
            <span>评论</span>
          </div>
          <div class="actions-btn">
            <span :class="{'on':sortType==1}" @click="hotList">热度</span>
            <span class="new" :class="{'on up':sortType==0,'on down':sortType==2}" @click="optionList">最新</span>
          </div>
        </div>
        <div class="comment-box">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="postContent"
            class="comment-input"
          >
          </el-input>
          <button class="comment-btn" @click="addPostComment(postContent,0)">评论</button>
        </div>
        <div class="comment-content-box">
          <ul class="comment-content-list">
            <li class="comment-item" v-for="(item,index) in commentList" :key="index">
              <div class="item-user-portrait">
                <img :src="item.HeadImgUrl" alt="头像" />
              </div>
              <div class="item-user-info">
                <h4>{{item.UserName}}<span v-if="item.IsAuthor" class="me">作者</span></h4>
                <el-dropdown trigger="click" placement="bottom" @command="commandMore" v-if="!item.IsDelete">
                  <span class="icon-more">点点点</span>
                  <el-dropdown-menu slot="dropdown" class="text-center">
                    <el-dropdown-item :command="beforeHandleCommand(index,item,'h',1)">回复</el-dropdown-item>
                    <el-dropdown-item :command="beforeHandleCommand(index,item,'k',1)">拷贝</el-dropdown-item>
                    <el-dropdown-item :command="beforeHandleCommand(index,item,'j',1)" v-if="!userInfo || item.UserCode != userInfo.UserCode">举报</el-dropdown-item>
                    <el-dropdown-item :command="beforeHandleCommand(index,item,'s',1)" v-else>删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <template v-if="!item.IsDelete">
                <p class="item-test" v-html="renderTxt(item.Content)"></p>
                <div class="item-img-list" v-if="item.ImgList && item.ImgList.length">
                  <div class="item-img-item" v-for="(img,idx) in item.ImgList" :key="idx">
                    <img :src="img" :preview="index" alt="图片">
                  </div>
                </div>
              </template>
              <template v-else>
                <p class="item-test">该评论已删除</p>
              </template>
              <div class="new-operation-btn" style="margin-top: 5px;">
                <span class="issue-time">{{item.CreateTime}}<span v-if="item.IsAuthorReply"> · 作者回复了</span></span>
                <div class="operation-btn" v-if="!item.IsDelete">
                  <span class="dz" :class="{'icon-yes-praise':item.IsThumbUp}" @click="forumThumbUpComment(index,1,item.Id)">{{item.ThumbUpCount}}</span>
                  <span class="pl icon-comment" @click="msgShow(index,1)">0</span>
                </div>
              </div>
              <el-collapse-transition>
                <div class="item-comment-box" v-show="item.showInput">
                    <el-input
                      type="textarea"
                      autosize
                      :placeholder="item.placeholder"
                      v-model="item.textarea"
                      class="item-comment-input"
                    >
                    </el-input>
                    <button class="item-comment-btn" @click="addPostComment(item.textarea,item.Id,index);item.textarea=''">评论</button>
                </div>
              </el-collapse-transition>
              <div class="items-comment-content-box">
                <el-collapse-transition>
                  <ul class="items-comment-content-list" v-show="item.showList" v-if="item.ChildCommentList.length">
                    <li class="items-comment-item" v-for="(items,indexs) in item.ChildCommentList" :key="indexs">
                      <div class="item-user-info">
                        <div class="items-hf"><span>{{items.UserName}}</span><i>回复</i><span>{{items.ParentUserName}}</span>：</div>
                        <el-dropdown trigger="click" placement="bottom" @command="commandMore">
                          <span class="icon-more">点点点</span>
                          <el-dropdown-menu slot="dropdown" class="text-center">
                            <el-dropdown-item :command="beforeHandleCommand(index,items,'h',2,indexs)">回复</el-dropdown-item>
                            <el-dropdown-item :command="beforeHandleCommand(index,items,'k',2,indexs)">拷贝</el-dropdown-item>
                            <el-dropdown-item :command="beforeHandleCommand(index,items,'j',2,indexs)" v-if="!userInfo || items.UserCode != userInfo.UserCode">举报</el-dropdown-item>
                            <el-dropdown-item :command="beforeHandleCommand(index,items,'s',2,indexs)" v-else>删除</el-dropdown-item>
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                      <p class="items-item-test" v-html="renderTxt(items.Content)"></p>
                      <div class="item-img-list" v-if="items.ImgList && items.ImgList.length">
                        <div class="item-img-item" v-for="(img,idx) in items.ImgList" :key="idx">
                          <img :src="img" :preview="index" alt="图片">
                        </div>
                      </div>
                      <div class="new-operation-btn" style="margin-top: 5px;">
                        <span class="issue-time">{{items.CreateTime}}</span>
                        <div class="operation-btn">
                          <span class="dz" :class="{'icon-yes-praise':items.IsThumbUp}" @click="forumThumbUpComment(index,2,items.Id,indexs)">{{items.ThumbUpCount}}</span>
                          <span class="pl icon-comment" @click="msgShow(index,2,indexs)">0</span>
                        </div>
                      </div>
                      <el-collapse-transition>
                        <div class="item-comment-box" v-show="items.showInput">
                            <el-input
                              type="textarea"
                              autosize
                              :placeholder="items.placeholder"
                              v-model="items.textarea"
                              class="item-comment-input"
                              style="width: 82.3%;"
                            >
                            </el-input>
                            <button class="item-comment-btn" @click="addPostComment(items.textarea,items.Id,index);items.textarea=''">评论</button>
                        </div>
                      </el-collapse-transition>
                    </li>
                  </ul>
                </el-collapse-transition>
                <div class="look-more" v-if="item.ChildCommentList && item.ChildCommentList.length">
                  <span @click="item.showList = !item.showList">{{item.showList?'收起':'展开'}}全部 <b>{{item.ChildCommentList.length}}</b> 条回复</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- right -->
      <div class="right-side-bar">
        <!-- top -->
        <div class="right-border-main" v-if="detail">
          <div class="user-side">
            <div class="user-top">
              <div class="user-content">
                <div class="user-portrait">
                  <div>
                    <img class="portrait" :src="detail.HeaderImgUrl" alt="头像">
                  </div>
                  <img v-if="detail.IsBpoOfficial" class="bv" src="@/assets/new/bbv.png" alt="图标">
                </div>
              </div>
              <div class="user-content" style="margin-top: 26px;">
                <div class="user-info">
                  <h3 class="user-title">{{detail.UserName}}</h3>
                  <img v-if="detail.IsBpoMember" src="@/assets/new/vip.png" style="width:20px;height:16px;" alt="vip">
                  <img v-if="detail.IsExpert" src="@/assets/new/master.png" style="width:24px;height:14px;" alt="大咖">
                </div>
              </div>
              <div class="user-content" style="margin-top: 40px;">
                <el-button v-if="!detail.IsFocusUser" class="attention" type="primary" icon="el-icon-plus" @click="focusUser(true)">关注</el-button>
                <el-button v-else class="attention" type="info" @click="focusUser(false)">已关注</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- bottom -->
        <div class="right-border-main">
          <h4 class="new-hot-title" style="color: #333333;">TA的热门作品</h4>
          <ul class="new-hot-list" v-if="hotPostList" style="padding-left: 20px">
            <li v-for="(item,index) in hotPostList" :key="index" @click="toDetail(item)">
              <div class="new-item-img" v-if="item.PostImgFileList instanceof Array && item.PostImgFileList.length">
                <img :src="item.PostImgFileList[0].FileUrl" alt="图片">
              </div>
              <p>{{item.Title}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <section class="main sec-main">
      <div class="content">
        <iframe ref="iframe" class="iframe" :src="newsUrl" frameborder="0"></iframe>
      </div>
    </section> -->
    <gk-footer></gk-footer>
    <my-dialog 
      class="report-dialog" 
      :show="showReport" 
      title="举报" 
      @close="showReport=false"
    >
      <div class="report-box">
        <div class="issue-one">
          <label for="" class="issue-label"><i style="color: red;">*</i>请选择举报原因</label>
          <ul class="option-report-list">
            <li :class="{'on':item.Id == ReasonId}" v-for="(item,index) in operationReason" :key="index" @click="ReasonId = item.Id">{{item.Reason}}</li>
          </ul>
        </div>
        <div class="issue-two">
          <label for="" class="issue-label">举报详情说明</label>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3}"
            placeholder="简略描述举报缘由"
            v-model="ComplainDescribe"
            class="issue-input"
          >
          </el-input>
        </div>
        <div class="report-btn">
          <button @click="forumComplain">确认</button>
        </div>
      </div>
    </my-dialog>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import gkFooter from '@/components/footer.vue'
import Dialog from "@/components/gkDialog.vue";
import {
  GetPostDetail,        //帖子详情
  ForumThumbUp,         //点赞或取消点赞
  ForumCollectPost,     //收藏或取消收藏
  GetPostCommentList,   //获取评论
  DeleteComment,        //删除评论
  AddPostComment,       //添加评论
  FocusUser,            //关注
  GetHotPostList,       //获取热门帖子
  GetOperationReason,   //获取投诉原因
  ForumComplain,        //举报
} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  components:{
    NavHeader,
    gkFooter,
    "my-dialog": Dialog
  },
  data(){
    return{
      detail: null,
      commentList:[],           //评论列表
      pageNum:1,
      pageSize:10,
      total:0,
      loading:false,
      sortType: 0,
      isUpDown: true,
      excludeIdArray: [],       // 添加完后过滤第一层
      postContent: '',          //帖子评论

      hotPostList: [],          //热门帖子

      operationReason: [],      //举报原因
      ReasonId: '',             //举报原因id
      ComplainDescribe:'',      //举报详细说明

      ContentId:'',             //帖子或评论id  举报用
      ContentType: '',          //帖子或评论1帖子,2评论

      // isShowVideo:false,
      // newsUrl:'',

      showReport:false,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  created() {
    
    this.$nextTick(() => {
      this.$previewRefresh(); //图片必须预览刷新才可以点击放大
    });
    // this.newsUrl=this.$route.query.url;
  },
  mounted() {
    
    let that=this;
    that.GetPostDetailInfo();
    that.getPostCommentList();
    this.onScroll();
    // window.onload=function () {
    //   console.log(1);
    //   console.dir(that.$refs.iframe)
    //   // console.log(window.frames)
    // }
  },
  watch: {
    $route(to, from) {
      console.log(1)
      this.$router.go(0)
    }
  },
  methods: {
    // 获取详情
    GetPostDetailInfo(){
      GetPostDetail({
        PostId: this.$route.query.id,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=>{
        this.detail = res.Data
        let id = res.Data.UserCode || 0
        this.getHotPostList(id)
      })
    },
    // 点赞文章或取消文章
    forumThumbUp() {
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      ForumThumbUp({
        ContentId:this.$route.query.id,
        ContentType: 1,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=> {
        if(res.Result !=1) {
          return this.$toast(res.Message);
        }
        this.detail.IsThumbUp = !this.detail.IsThumbUp
        if(this.detail.IsThumbUp) {
          this.detail.ThumbUpCount = this.detail.ThumbUpCount+1
        }else {
          this.detail.ThumbUpCount = this.detail.ThumbUpCount-1
        }
      })
    },
    // 点赞评论或取消评论
    forumThumbUpComment(idx,is,id,idxs){
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      ForumThumbUp({
        ContentId:id,
        ContentType: 2,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=> {
        if(res.Result !=1) {
          return this.$toast(res.Message);
        }
        if(is==1) {
          this.commentList[idx].IsThumbUp = !this.commentList[idx].IsThumbUp
          if(this.commentList[idx].IsThumbUp) {
            this.commentList[idx].ThumbUpCount = this.commentList[idx].ThumbUpCount+1
          }else {
            this.commentList[idx].ThumbUpCount = this.commentList[idx].ThumbUpCount-1
          }
        }else {
          this.commentList[idx].ChildCommentList[idxs].IsThumbUp = !this.commentList[idx].ChildCommentList[idxs].IsThumbUp
          if(this.commentList[idx].ChildCommentList[idxs].IsThumbUp) {
            this.commentList[idx].ChildCommentList[idxs].ThumbUpCount = this.commentList[idx].ChildCommentList[idxs].ThumbUpCount+1
          }else{
            this.commentList[idx].ChildCommentList[idxs].ThumbUpCount = this.commentList[idx].ChildCommentList[idxs].ThumbUpCount-1
          }
        }
      })
    },
    // 收藏或取消
    forumCollectPost(){
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      ForumCollectPost({
        PostId: this.$route.query.id,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
      }).then(res=> {
        if(res.Result !=1) {
          return this.$toast(res.Message);
        }
        this.detail.IsCollect = !this.detail.IsCollect
        if(this.detail.IsCollect) {
          this.detail.CollectCount = this.detail.CollectCount+1
        }else {
          this.detail.CollectCount = this.detail.CollectCount-1
        }
      })
    }, 
    // 获取评论
    getPostCommentList(){
      if(this.loading==true){
        return;
      }
      this.loading=true;
      GetPostCommentList({
        UserCode: this.userInfo?this.userInfo.UserCode : '',
        PostId: this.$route.query.id,
        ExcludeIdArray: this.excludeIdArray,
        SortType: this.sortType,
        PageNum: this.pageNum,
        PageSize: this.pageSize,
      }).then(res=> {
        let list=res.Data.PostCommentList ||[];
        let lists = list.map(elem=>{
          elem.placeholder = '回复'+elem.UserName+':'
          elem.showInput = false
          elem.textarea = ''
          if(elem.ChildCommentList instanceof Array && 
            elem.ChildCommentList.length <= 2) {
              elem.showList = true
            }else{
              elem.showList = false
            }
          if(
            elem.ChildCommentList instanceof Array && 
            elem.ChildCommentList.length
          ) {
            elem.ChildCommentList.map(elems=>{
              elems.placeholder = '回复'+elems.UserName+':'
              elems.showInput = false
              elems.textarea = ''
            })
          }
          return elem
        })
        if(this.pageNum==1){
          this.commentList = []
          this.commentList = lists
          //如果是第一页，页面滚动到首屏
          // this.$nextTick(()=>{
          //   document.documentElement.scrollIntoView(true);
          // })
        }else{
          this.commentList=this.commentList.concat(lists);
        }
        if(this.pageSize==lists.length){
          this.loading=false;
          this.pageNum=this.pageNum+1;
        }
      })
    },
    //滚动加载
    onScroll(){
      let scrollTop=document.documentElement.scrollTop;
      let that=this;
      document.onscroll=function () {
        let clientHeight=document.documentElement.clientHeight;
        let offsetHeight=document.documentElement.offsetHeight;
        let st=document.documentElement.scrollTop;
        let flag=0;//向下滚动时变成1；
        if(st>scrollTop){
          flag=1;
        }else{
          flag=0;
        }
        scrollTop=st;
        if(offsetHeight-clientHeight-50<=st && flag){
          that.getPostCommentList();
        }
      }
    },

    // 点击显示评论
    msgShow(idx,is,idxs) {
      if(is == 1) {
        this.commentList[idx].showInput = !this.commentList[idx].showInput
      }else {
        this.commentList[idx].ChildCommentList[idxs].showInput = !this.commentList[idx].ChildCommentList[idxs].showInput
      }
    },

    // 点击热度
    hotList() {
      if(this.sortType == 1) {
        return
      }
      this.sortType = 1
      this.loading=false;
      this.pageNum = 1;
      this.pageSize = 10;
      this.excludeIdArray=[]
      this.getPostCommentList();
    },
    // 点击最新
    optionList(){
      if(this.sortType == 0) {
        this.sortType = 2
      }else {
        this.sortType = 0
      }
      this.loading=false;
      this.pageNum = 1;
      this.pageSize = 10;
      this.excludeIdArray=[]
      this.getPostCommentList();
    },
    // 点击更多
    commandMore(command){
      console.log(command)
      switch (command.command) {
        case "h"://回复
          if(command.is == 1) {
            this.msgShow(command.index,1)
          }else {
            this.msgShow(command.index,2,command.indexs)
          }
          break;
        case "k"://拷贝
          var aux = document.createElement("input"); 
          aux.setAttribute("value", command.row.Content); 
          document.body.appendChild(aux); 
          aux.select();
          document.execCommand("copy"); 
          document.body.removeChild(aux);
          this.$toast("复制成功");
          break;
        case "j"://举报
          if(!this.userInfo){
            this.$router.push('/companyLogin');
            return;
          }
          this.ReasonId = '';
          this.ContentId = '';
          this.ContentType = '';
          this.operationReason = [];
          this.ComplainDescribe = '';
          this.getOperationReason(command)
          break;
        case "s"://删除
          this.deleteCommand(command.index,command.row,command.is,command.indexs)
          break;
      }
    },
    // 帖子传多个参数
    textHandleCommand(command){
      return {
        'row':{Content:window.location.href},
        'command':command
      }
    },
    // 评论传多个参数
    beforeHandleCommand(index,row,command,is,indexs) {
      return {
        'index': index,
        'row': row,
        'command': command,
        'is': is,
        'indexs': indexs
      }
    },
    // 删除评论
    deleteCommand(index,row,is,indexs){
      let self = this
      this.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DeleteComment({
          Id: row.Id,
          UserCode: this.userInfo?this.userInfo.UserCode : '',
        }).then(res=> {
          if(res.Result != 1) {
            return this.$toast(res.Message);
          }
          if(is == 1) {
            if(self.commentList[index].ChildCommentList instanceof Array  && self.commentList[index].ChildCommentList.length) {
              self.commentList[index].IsDelete = true
            }else {
              self.commentList.splice(index, 1);
            }
          }else {
            self.commentList[index].ChildCommentList.splice(indexs, 1)
          }
          self.$toast('删除成功！')
        })
      }).catch(() => {});
    },
    // 添加评论
    addPostComment(content,parentId,index){
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      let self = this
      AddPostComment({
        PostId: this.$route.query.id,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
        Content: content,
        ParentId: parentId,
        ImgArray: [],       //暂无功能
      }).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message)
        }
        if(parentId == 0) {
          let elem = res.Data
          elem.placeholder = '回复'+elem.UserName+':'
          elem.showInput = false
          elem.showList = false
          elem.textarea = ''
          self.commentList.unshift(elem)
          self.excludeIdArray.push(elem.Id)
          self.postContent = ''
        }else {
          let elem = res.Data
          elem.placeholder = '回复'+elem.UserName+':'
          elem.showInput = false
          elem.textarea = ''
          self.commentList[index].showList = true
          self.commentList[index].ChildCommentList.push(elem)
        }
      })
    },
    // 点击关注或取消关注
    focusUser(is){
      if(!this.userInfo){
        this.$router.push('/companyLogin');
        return;
      }
      FocusUser({
        UserCode: this.userInfo?this.userInfo.UserCode : '',
        FocusUserCode: this.detail.UserCode,
        IsFocus:is,
      }).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message)
        }
        this.detail.IsFocusUser = !this.detail.IsFocusUser
      })
    },
    // 获取热门帖子
    getHotPostList(id){
      GetHotPostList({
        UserCode: id?id:'',
        PageNum: 1,
        PageSize: 6
      }).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message)
        }
        this.$nextTick(()=>{
          this.hotPostList = res.Data.PostList
        })
      })
    },
    //打开详情
    toDetail(item){
      let url = ''
      if(process.env.NODE_ENV == 'development') {
        url = window.location.protocol+'//'+window.location.host+'/#/newsDetail?id='+item.Id
      }else {
        url = window.location.protocol+'//'+window.location.host+'/site/#/newsDetail?id='+item.Id
      }
      window.open(url,'_blank');
    },
    // 获取投诉选项
    getOperationReason(command){
      this.showReport = true
      if(command.is == 1) {
        this.ContentId = command.row.Id
        this.ContentType = 2
      }else {
        this.ContentId = this.$route.query.id
        this.ContentType = 1
      }
      GetOperationReason({
        type: 6
      }).then(res=> {
        this.operationReason = res.Data
      })
    },
    // 点击举报
    forumComplain() {
      if(!this.ReasonId) {
        return this.$toast('请选择举报原因！');
      }
      ForumComplain({
        ContentId: this.ContentId,
        ContentType: this.ContentType,
        UserCode: this.userInfo?this.userInfo.UserCode : '',
        ReasonId: this.ReasonId,
        ComplainDescribe: this.ComplainDescribe
      }).then(res=> {
        if(res.Result != 1) {
          return this.$toast(res.Message);
        }
        this.$toast(res.Message)
        this.showReport = false
      })
    },
    //渲染表情图片
    customEmoji(value) {
      var html='';
      var str = value.replace(/\[|]/g,'')
      html=`<img src="https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Emoji/${str}.png" style="width:30px"/>`
      return html;
    },
    //渲染消息文字和表情图片
    renderTxt(txt = "") {
      let rnTxt = [];
      let match = null;
      const regex = /(\[.*?\])/g;
      // const regex = /\[|]/g;
      let start = 0;
      let index = 0;
      while ((match = regex.exec(txt))) {
        index = match.index;
        if (index > start) {
          rnTxt.push(txt.substring(start, index));
        }
        rnTxt.push(this.customEmoji(match[1]));
        start = index + match[1].length;
      }
      rnTxt.push(txt.substring(start, txt.length));
      return rnTxt.join('');//.replace(/,/g, "")
    },
  },
  destroyed() {
    document.onscroll=null;
  },
}
</script>
<style lang="scss">
.newsDetail{
  padding-top:68px;
  .sec-main{
    min-height: 85vh;
    // overflow: hidden;
    padding-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  .iframe{
    width: 100%;
    height: 500px;
    html,body{
      overflow: hidden;
    }
  }
  .list-wrapper {
    width: 690px;
    float: left;
    textarea{resize:none}
    .new-article-title {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      line-height: 36px;
      margin-bottom: 30px;
    }
  }
  .new-operation-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .issue-time {
      font-size: 16px;
      color: #999999;
      font-weight: 400;
    }
  }
  .operation-btn {
    .dz,
    .sc,
    .pl {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      color: #999999;
      font-size: 18px;
      line-height: 22px;
      padding-left: 24px;
      background-repeat: no-repeat;
      background-position: left center;
      cursor: pointer;
    }
    .dz {
      background-image: url('~@/assets/new/icon-no-praise.png');
    }
    .icon-yes-praise {
      background-image: url('~@/assets/new/icon-yes-praise.png');
    }
    .sc {
      margin-right: 20px;
      background-image: url('~@/assets/new/icon-no-collect.png');
    }
    .icon-yes-collect {
      background-image: url('~@/assets/new/icon-yes-collect.png');
    }
    .el-dropdown {
      vertical-align: top;
    }
    .pl {
      font-size: 0;
    }
    .icon-comment {
      background-image: url('~@/assets/new/icon-comment.png');
    }
  }
  .icon-more {
    display: inline-block;
    vertical-align: top;
    width: 22px;
    height: 22px;
    background-image: url('~@/assets/new/icon-more.png');
    background-repeat: no-repeat;
    background-position: center center;
    font-size: 0;
    cursor: pointer;
  }
  .contentNum-actions {
    height: 106px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .comment-number {
      i {
        font-size: 34px;
        color: #f75959;
        font-weight: bold;
      }
      span {
        padding-left: 6px;
        font-size: 22px;
        color: #333333;
        font-weight: bold;
      }
    }
    .actions-btn {
      background: #eeeeee;
      padding: 4px 5px;
      height: 38px;
      border-radius: 19px;
      display: flex;
      align-items: center;
      position: relative;
      span {
        font-size: 16px;
        color: #999999;
        padding: 0 12px;
        line-height: 30px;
        width: 60px;
        text-align: center;
        cursor: pointer;
      }
      span.on {
        background: #ffffff;
        border-radius: 15px;
        color: #333333;
        font-weight: bold;
        position: relative;
        z-index: 1;
      }
      span.new {
        margin-left: -10px;
        background-repeat: no-repeat;
        background-position: 47px center;
        background-size: 10px 16px;
        -webkit-filter: grayscale(.95);
        background-image: url('~@/assets/new/icon-zx.png');
      }
      span.up {
        -webkit-filter: grayscale(0);
        background-image: url('~@/assets/new/icon-zx.png');
      }
      span.down {
        -webkit-filter: grayscale(0);
        background-image: url('~@/assets/new/icon-dx.png');
      }
    }
  }
  .comment-box {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    .comment-input {
      textarea {
        min-height: 41px;
        height: 41px;
        padding: 9px 15px !important;
        border-radius: 10px;
        border: 1px solid #E0E0E0;
      }
    }
    .comment-btn {
      width: 74px;
      height: 40px;
      color: #ffffff;
      border-radius: 10px;
      font-size: 22px;
      border: none;
      background: #f75959;
      margin-left: 34px;
      line-height: 40px;
    }
  }
  .comment-content-box {
    margin-top: 30px;
    ul.comment-content-list {
      li.comment-item {
        margin-top: 20px;
        padding-left: 37px;
        padding-bottom: 20px;
        position: relative;
        border-bottom: 1px solid #e5e5e5;
        .item-user-portrait {
          position: absolute;
          left: 0;
          top: 0;
          width: 30px;
          height: 30px;
          overflow: hidden;
          border-radius: 50%;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .item-user-info {
          margin-bottom: 8px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          h4 {
            color: #333333;
            font-size: 16px;
            font-weight: 600;
            display: flex;
            align-items: center;
            .me {
              border: 1px solid #999999;
              color: #999999;
              font-size: 12px;
              margin-left: 8px;
              border-radius: 4px;
              padding: 0 4px;
              line-height: 16px;
              font-weight: 500;
            }
          }
        }
        .item-test,
        .items-item-test {
          font-size: 16px;
          color: #666666;
          font-weight: 400;
          line-height: 30px;
        }
        .item-img-list {
          display: flex;
          align-items: center;
          div.item-img-item {
            flex: 0 0 30%;
            height: 160px;
            margin-right: 20px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .item-comment-box {
          margin-top: 15px;
          // display: flex;
          // justify-content: space-around;
          // align-items: flex-end;
          .item-comment-input {
            display: inline-block;
            vertical-align: top;
            width: 83.4%;
            textarea {
              border-radius: 10px;
              border: 1px solid #E0E0E0;
            }
          }
          .item-comment-btn {
            display: inline-block;
            vertical-align: bottom;
            width: 74px;
            height: 33px;
            color: #ffffff;
            border-radius: 10px;
            font-size: 18px;
            border: none;
            background: #f75959;
            margin-left: 34px;
          }
        }
        .items-comment-content-box {
          margin-top: 15px;
          ul.items-comment-content-list {
            background: #f9f9f9;
            border-radius: 10px;
            padding: 5px 20px 0px;
            li.items-comment-item {
              border-bottom: 1px solid #e5e5e5;
              padding-bottom: 16px;
              .item-user-info {
                padding-top: 5px;
                height: 40px;
                margin-bottom: 0;
                .items-hf {
                  color: #333333;
                  font-size: 16px;
                  i {
                    color: #999999;
                    padding: 0 6px;
                  }
                }
              }
            }
            li.items-comment-item:last-child {
              border-bottom: none;
            }
          }
        }
        .look-more {
          display: flex;
          align-items: center;
          height: 16px;
          margin-top: 20px;
          span {
            color: #f75959;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
      li.comment-item:last-child {
        border-bottom: none;
      }
    }
  }
  .right-side-bar {
    .right-border-main {
      margin-top: 14px;
      margin-bottom: 50px;
      width: 318px;
      min-height: 140px;
      border-radius: 2px;
      -webkit-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      -moz-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      -o-box-shadow: 0 0 8px rgba(34, 23, 20, .1);
      box-shadow: 0 0 8px rgba(34, 23, 20, .1);
    }
    .user-side {
      padding: 30px 20px;
      .user-top {
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        margin-bottom: 10px;
        min-height: 32px;
        .user-content {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          .user-portrait {
            position: relative;
            width: 70px;
            height: 70px;
            > div {
              width: 70px;
              height: 70px;
              overflow: hidden;
              border-radius: 50%;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .bv {
              display: block;
              width: 30px;
              height: 30px;
              object-fit: cover;
              position: absolute;
              right: -4px;
              bottom: -4px;
            }
          }
        }
        .user-info {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .user-title {
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          img {
            display: inline-block;
            vertical-align: top;
            margin-left: 6px; 
          }
        }
        .attention {
          width: 120px;
          height: 36px;
          // line-height: 36px;
          padding: 8px 20px;
          font-size: 14px;
          border-radius: 0;
        }
      }
    }
    .new-hot-title {
      font-size: 16px;
      color: #666666;
      font-weight: 400;
      padding-left: 20px;
      line-height: 55px;
      height: 55px;
      border-bottom: 1px solid #e5e5e5;
      // background-image: url('~@/assets/new/icon-hot.png');
      // background-repeat: no-repeat;
      // background-position: 19px 15px;
      // background-size: 20px 20px;
    }
    .new-hot-list {
      padding: 0 20px 0 10px;
      overflow: hidden;
      li {
        display: flex;
        align-items: flex-start;
        font-size: 14px;
        line-height: 24px;
        color: #666666;
        margin: 20px 0;
        cursor: pointer;
        .new-item-img {
          max-width: 116px;
          min-width: 116px;
          height: 65px;
          overflow: hidden;
          display: inline-block;
          vertical-align: top;
          margin-right: 10px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        p {
          margin-top: -4px;
          line-height: 22px;
          overflow: hidden;
          display: -webkit-box;
          // text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
        &:hover {
          color: #f75959;
        }
      }
    }
  }
}
.text-center {
  li {
    text-align: center;
  }
}

.report-box {
  .issue-label {
    color: #333333;
    font-size: 16px;
    font-weight: 600;
    line-height: 48px;
  }
  .option-report-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      margin-right: 20px;
      min-width: 120px;
      text-align: center;
      margin-bottom: 20px;
      padding: 14px 12px;
      border: 1px solid #f9f9f9;
      background: #f9f9f9;
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }
    li.on {
      border: 1px solid #f75959;
      color: #f75959;
    }
  }
  .issue-input {
    textarea {
      resize:none;
      border: 1px solid #E0E0E0;
    }
  }
  .report-btn {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    button {
      flex: 0 0 100px;
      height: 30px;
      background: #f75959;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      border: 1px solid #f75959;
      line-height: 28px;
    }
  }
}

.link-card-box {
        margin: 1em auto;
        width: 390px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 12px;
        max-width: 100%;
        overflow: hidden;
        display: flex;
                align-items: center;
                justify-content: space-between;
                border-radius: inherit;
                background-color: hsla(0,0%,96.5%,.88);
                padding: 12px;
        // a {
            // > span {
            //     display: flex;
            //     align-items: center;
            //     justify-content: space-between;
            //     border-radius: inherit;
            //     background-color: hsla(0,0%,96.5%,.88);
            //     padding: 12px;
            // }
        // }
        .link-card-text {
            flex: 0 0 300px;
            overflow: hidden;
            .link-card-title {
                display: block;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                max-height: 40px;
                font-size: 16px;
                font-weight: 500;
                line-height: 1.25;
                word-wrap: break-word;
                color: #121212;
            }
            .link-card-meta{
                // display: -webkit-box;
                // display: -ms-flexbox;
                // display: flex;
                display: block;
                margin-top: 4px;
                font-size: 14px;
                line-height: 20px;
                color: #999;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: initial;
                word-wrap: break-word;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .link-card-image-cell {
            margin-left: 8px;
            border-radius: 6px;
            min-width: 60px;
            min-height: 60px;
            img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .report-dialog {
      .dialog-title {
        text-align: center;
      }
    }
</style>